export const SET_LOCALE = 'SET_LOCALE';
export const SET_USER = 'SET_USER';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_CONTRIBUTIONS = 'SET_CONTRIBUTIONS';
export const EDIT_CONTRIBUTION = 'EDIT_CONTRIBUTION';
export const ADD_CONTRIBUTION = 'ADD_CONTRIBUTION';
